import { Component, OnInit, OnDestroy, ChangeDetectorRef, AfterViewInit, ViewChild, Output, EventEmitter } from '@angular/core';
import { MenuItem, MessageService } from 'primeng/api';
import {ConfigService, AppDataService, PromosService} from 'app/services';
import { EditTableConfig } from 'app/models/configs/edit-table-config';
import {ExportFileTypeModel, FieldTypeEnum} from 'app/models';
import { ColumnSelectorComponent } from 'app/column-selector/column-selector.component';
import { TableLazyLoadEvent } from 'primeng/table';
import { Utils } from 'app/utils';
import * as moment from 'moment/moment';

enum XpressDeliveryStatusEnum {
    Pending = 1,
    Accepted = 2,
    RiderAssigned = 3,
    ArrivedToPickup = 4,
    PickedUp = 5,
    ArrivedToDrop = 6,
    Completed = 7,
    Canceled = 8,
}

@Component({
    selector: 'discounts-report',
    templateUrl: './discounts-report.component.html',
    styleUrls: ['./discounts-report.component.scss',
        '../../../../styles/paginator.scss'],
    providers: [MessageService]
})

export class DiscountsReportComponent implements OnInit, OnDestroy, AfterViewInit {

    @ViewChild(ColumnSelectorComponent)
    public columnSelector!: ColumnSelectorComponent;

    orders: Array<any> = [];
    cols: any[] = [
        {
            field: 'Id',
            header: 'Booking ID',
            width: '8%',
            fieldType: FieldTypeEnum.InputNumber,
            model: 'id',
            placeholder: 'Type ID',
            active: true,
        },
        {
            field: 'XpressUserId',
            header: 'Customer Id',
            width: '8%',
            fieldType: FieldTypeEnum.InputNumber,
            model: 'xpressUserId',
            placeholder: 'Type ID',
            active: true,
        },
        {
            field: 'CustomerName',
            header: 'Customer Name',
            width: '12%',
            fieldType: FieldTypeEnum.Inputs,
            model: 'customerName',
            placeholder: 'Type Name',
            active: true,
            action: (rowData: any) => this.handleShowCustomerInfo(rowData)
        },
        {
            field: 'XpressRiderId',
            header: 'Driver ID',
            width: '8%',
            fieldType: FieldTypeEnum.InputNumber,
            model: 'xpressRiderId',
            placeholder: 'Type ID',
            active: true,
        },
        {
            field: 'DriverName',
            header: 'Driver Name',
            width: '12%',
            fieldType: FieldTypeEnum.Inputs,
            model: 'driverName',
            placeholder: 'Type Name',
            active: true,
        },
        {
            field: 'InitialTotalFareAmount',
            header: 'Full Price',
            width: '10%',
            fieldType: FieldTypeEnum.InputDecimalNumber,
            model: 'initialTotalFareAmount',
            placeholder: 'Type Amount',
            active: true,
        },
        {
            field: 'PromoAmount',
            header: 'Discounted Amount',
            width: '10%',
            fieldType: FieldTypeEnum.InputDecimalNumber,
            model: 'promoAmount',
            placeholder: 'Type Amount',
            active: true,
        },
        {
            field: 'PromoName',
            header: 'Promo Name',
            width: '12%',
            fieldType: FieldTypeEnum.Inputs,
            model: 'promoName',
            placeholder: 'Type Name',
            active: true,
        },
        {
            field: 'PromoCode',
            header: 'Promo Code',
            width: '10%',
            fieldType: FieldTypeEnum.Inputs,
            model: 'promoCode',
            placeholder: 'Type Code',
            active: true,
        },
        {
            field: 'StatusName',
            header: 'Order Status',
            width: '10%',
            fieldType: FieldTypeEnum.Dropdown,
            model: 'statusId',
            placeholder: 'Select Status',
            options: this.getOrderStatusOptions(),
            active: true,
        },
        {
            field: 'DisplayFormatCreatedAt',
            header: 'Created At',
            width: '15%',
            fieldType: FieldTypeEnum.Calendar,
            model: 'createdAt',
            placeholder: 'Select Date',
            active: true,
        },
    ];
    defaultCols = this.cols.map(x => x);

    rowsPerPage: number = 15;
    totalRecords: number = -1;
    fieldTypeEnum = FieldTypeEnum;
    visibleCustomerDetail: boolean = false;
    transactionCustomerId: number = 0;
    selectedOrder: any;
    orderHeaderSearch: any = {
        id: null,
        xpressUserId: null,
        customerName: null,
        xpressRiderId: null,
        driverName: null,
        initialTotalFareAmount: null,
        promoAmount: null,
        promoName: null,
        promoCode: null,
        statusId: null,
        createdAt: null,
        startDate: null,
        endDate: null,
    };
    first: number = 0;
    sortField: string | string[] = 'Id';
    sortOrder: number = -1;
    loading: boolean = false;
    searchTimer: any = 0;
    tableName: string = EditTableConfig.ORDERS_REPORT;
    exportHeaderColumns: string[] = [];
    exportDataColumns: string[] = [];

    public showDetailOrderSideBar: boolean = false;
    public showExportSidebar: boolean = false;
    public exportLoading: boolean = false;
    public exportData: any = {};

    breadcrumbs: MenuItem[] = [{ icon: 'icon_orders' }, { label: 'Reports' }, { label: 'Orders Report' }];

    constructor(
        private messageService: MessageService,
        private promosService: PromosService,
        public configService: ConfigService,
        private cdRef: ChangeDetectorRef,
        public appDataService: AppDataService) {
        this.handleShowCustomerInfo = this.handleShowCustomerInfo.bind(this);
    }

    ngAfterViewInit(): void {
        this.cdRef.detectChanges();
    }

    ngOnInit(): void {
    }

    ngOnDestroy(): void {
        if (this.searchTimer) {
            clearTimeout(this.searchTimer);
        }
    }

    @Output() changedVisibleExportSidebarEmit = new EventEmitter<boolean>();
    changedVisibleExportSidebar(increased: any) {
        this.changedVisibleExportSidebarEmit.emit(increased);
    }

    export() {
        if (!this.exportData.fileType) {
            this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Please select file type' });
            return;
        }

        this.exportLoading = true;
        const requestDto = {
            Id: this.orderHeaderSearch.id ? Number(this.orderHeaderSearch.id) : null,
            XpressUserId: this.orderHeaderSearch.xpressUserId ? Number(this.orderHeaderSearch.xpressUserId) : null,
            CustomerName: this.orderHeaderSearch.customerName || null,
            XpressRiderId: this.orderHeaderSearch.xpressRiderId ? Number(this.orderHeaderSearch.xpressRiderId) : null,
            DriverName: this.orderHeaderSearch.driverName || null,
            InitialTotalFareAmount: this.orderHeaderSearch.initialTotalFareAmount ? Number(this.orderHeaderSearch.initialTotalFareAmount) : null,
            PromoAmount: this.orderHeaderSearch.promoAmount ? Number(this.orderHeaderSearch.promoAmount) : null,
            PromoName: this.orderHeaderSearch.promoName || null,
            PromoCode: this.orderHeaderSearch.promoCode || null,
            StatusId: this.orderHeaderSearch.statusId ?? null,
            CreatedAtFrom: this.orderHeaderSearch.startDateFormatted ? moment(this.orderHeaderSearch.startDate).startOf('day').toDate() : null,
            CreatedAtTo: this.orderHeaderSearch.endDateFormatted ? moment(this.orderHeaderSearch.endDate).endOf('day').toDate() : null,

            SortField: this.sortField,
            SortOrder: this.sortOrder,
            IsExport: true,
            FileType: this.exportData.fileType,
            HeaderColumns: this.exportHeaderColumns,
            DataColumns: this.exportDataColumns,
            TimeZoneOffset: Utils.getTimezoneOffset(),
            ClientLocationType: this.appDataService.getClientLocationType(),
        };

        this.promosService.downloadOrders(requestDto, this.messageService)
            .then(data => {
                this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Report downloaded successfully.' });
                Utils.saveFileResponse(data, 'Orders-Report-' + moment(new Date()).format('DD MMM YYYY hh:mm:ss A'), this.exportData.fileType);
                this.exportLoading = false;
            })
            .catch(err => {
                this.exportLoading = false;
                throw err;
            });
    }

    showSidebar() {
        this.showExportSidebar = true;
    }

    getOrderStatusOptions(): { name: string; value: XpressDeliveryStatusEnum | null }[] {
        const options: { name: string; value: XpressDeliveryStatusEnum | null }[] = [{ name: 'All (Successful/Canceled)', value: null }];
        for (const status in XpressDeliveryStatusEnum) {
            if (isNaN(Number(status))) {
                const successfulStatuses = [ XpressDeliveryStatusEnum.Completed ];
                const canceledStatuses = [ XpressDeliveryStatusEnum.Canceled];
                const value = XpressDeliveryStatusEnum[status as keyof typeof XpressDeliveryStatusEnum];
                if (successfulStatuses.includes(value) || canceledStatuses.includes(value)) {
                    options.push({ name: status, value });
                }
            }
        }
        return options;
    }

    onSelectedColumnsChange(event: any[]) {
        if (event && event.length > 0) {
            this.cols = event;
        }
        else {
            this.cols = [...this.defaultCols];
        }
        this.updateExportColumns();
    }

    updateExportColumns(): void {
        this.exportHeaderColumns = this.cols.map(x => x.header);
        this.exportDataColumns = this.cols.map(x => x.field);
    }

    handleLazyLoad(event: TableLazyLoadEvent): void {
        const skip = event.first ?? 0;
        if (event.rows) {
            this.rowsPerPage = event.rows;
        }

        if (!event.sortField) {
            this.sortField = 'Id';
            this.sortOrder = -1;
        }
        else {
            this.sortField = typeof event.sortField === 'string' ? event.sortField : 'Id';
            this.sortOrder = event.sortOrder ?? 1;
        }

        if (this.columnSelector) {
            this.columnSelector.loadTableSettings(this.tableName);
        } else {
            this.cols = [...this.defaultCols];
            this.updateExportColumns();
        }

        this.loadOrders(skip);
    }

    handleFilterChange(modelField: string, event: any): void {
        let value = event?.target?.value ?? event;
        if (value === '') {
            value = null;
        }

        this.orderHeaderSearch[modelField] = value;

        if (this.searchTimer) {
            clearTimeout(this.searchTimer);
        }

        this.searchTimer = setTimeout(() => {
            this.first = 0;
            this.loadOrders(0);
        }, 1000);
    }

    onChangeHeaderFilterDropDown(modelField: string, event: any) {
        this.orderHeaderSearch[modelField] = event;

        if (modelField === 'createdAt' && this.orderHeaderSearch.createdAt instanceof Date) {
            this.orderHeaderSearch.createdAtFormatted = moment(this.orderHeaderSearch.createdAt).format('YYYY-MM-DD');
        }

        if (modelField === 'StartDate' && this.orderHeaderSearch.startDate instanceof Date) {
            this.orderHeaderSearch.startDateFormatted = moment(this.orderHeaderSearch.startDate).format('YYYY-MM-DD');
        }

        if (modelField === 'EndDate' && this.orderHeaderSearch.endDate instanceof Date) {
            this.orderHeaderSearch.endDateFormatted = moment(this.orderHeaderSearch.endDate).format('YYYY-MM-DD');
        }

        if (this.searchTimer) {
            clearTimeout(this.searchTimer);
        }
        this.searchTimer = setTimeout(() => {
            this.first = 0;
            this.loadOrders(0);
        }, 1000);
    }


    handleShowCustomerInfo(order: any) {
        this.transactionCustomerId = order.XpressUserId;
        this.visibleCustomerDetail = true;
    }

    changedVisibleCustomerDetailEmit(value: boolean) {
        this.visibleCustomerDetail = value;
    }

    loadOrders(skip: number) {
        this.loading = true;
        const requestDto = {
            Id: this.orderHeaderSearch.id ? Number(this.orderHeaderSearch.id) : null,
            XpressUserId: this.orderHeaderSearch.xpressUserId ? Number(this.orderHeaderSearch.xpressUserId) : null,
            CustomerName: this.orderHeaderSearch.customerName || null,
            XpressRiderId: this.orderHeaderSearch.xpressRiderId ? Number(this.orderHeaderSearch.xpressRiderId) : null,
            DriverName: this.orderHeaderSearch.driverName || null,
            InitialTotalFareAmount: this.orderHeaderSearch.initialTotalFareAmount ? Number(this.orderHeaderSearch.initialTotalFareAmount) : null,
            PromoAmount: this.orderHeaderSearch.promoAmount ? Number(this.orderHeaderSearch.promoAmount) : null,
            PromoName: this.orderHeaderSearch.promoName || null,
            PromoCode: this.orderHeaderSearch.promoCode || null,
            StatusId: this.orderHeaderSearch.statusId ?? null,
            CreatedAtFrom: this.orderHeaderSearch.startDateFormatted ? moment(this.orderHeaderSearch.startDate).startOf('day').toDate() : null,
            CreatedAtTo: this.orderHeaderSearch.endDateFormatted ? moment(this.orderHeaderSearch.endDate).endOf('day').toDate() : null,

            Skip: skip,
            Take: this.rowsPerPage,
            SortField: this.sortField,
            SortOrder: this.sortOrder,
            TimeZoneOffset: Utils.getTimezoneOffset(),
            ClientLocationType: this.appDataService.getClientLocationType(),
            IsExport: false
        };

        this.promosService.getOrders(requestDto, this.messageService)
            .then(data => {
                this.loading = false;
                if (!data.Success) {
                    this.messageService.add({ severity: 'error', summary: 'Error', detail: data.ErrorMessage || 'Failed to load orders.' });
                    return;
                }
                this.first = skip;
                this.totalRecords = data.TotalRecords;
                this.orders = data.Orders.map((o: any) => {
                    o.DisplayFormatCreatedAt = moment(o.CreatedAt).format('DD MMM YYYY | hh:mmA');
                    return o;
                });
            })
            .catch(err => {
                this.loading = false;
                this.messageService.add({ severity: 'error', summary: 'Error', detail: 'An error occurred while fetching orders.' });
                console.error(err);
            });
    }

    onSelectionChange(event: any) {
        this.selectedOrder = event;
    }

    onDownloadClick(): void {
        this.loading = true;
        const requestDto = {
            Id: this.orderHeaderSearch.id ? Number(this.orderHeaderSearch.id) : null,
            XpressUserId: this.orderHeaderSearch.xpressUserId ? Number(this.orderHeaderSearch.xpressUserId) : null,
            CustomerName: this.orderHeaderSearch.customerName || null,
            XpressRiderId: this.orderHeaderSearch.xpressRiderId ? Number(this.orderHeaderSearch.xpressRiderId) : null,
            DriverName: this.orderHeaderSearch.driverName || null,
            InitialTotalFareAmount: this.orderHeaderSearch.initialTotalFareAmount ? Number(this.orderHeaderSearch.initialTotalFareAmount) : null,
            PromoAmount: this.orderHeaderSearch.promoAmount ? Number(this.orderHeaderSearch.promoAmount) : null,
            PromoName: this.orderHeaderSearch.promoName || null,
            PromoCode: this.orderHeaderSearch.promoCode || null,
            StatusId: this.orderHeaderSearch.statusId ?? null,
            CreatedAtFrom: this.orderHeaderSearch.createdAt ? moment(this.orderHeaderSearch.createdAt).startOf('day').toDate() : null,
            CreatedAtTo: this.orderHeaderSearch.createdAt ? moment(this.orderHeaderSearch.createdAt).endOf('day').toDate() : null,

            SortField: this.sortField,
            SortOrder: this.sortOrder,
            IsExport: true,
            HeaderColumns: this.exportHeaderColumns,
            DataColumns: this.exportDataColumns,
            TimeZoneOffset: Utils.getTimezoneOffset(),
            ClientLocationType: this.appDataService.getClientLocationType(),
        };

        this.promosService.downloadOrders(requestDto, this.messageService)
            .then(data => {
                this.loading = false;
                Utils.saveFileResponse(data, 'Orders-Report-' + new Date().valueOf() + '.xlsx');
                this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Report downloaded successfully.' });
            })
            .catch(err => {
                this.loading = false;
                this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Failed to download report.' });
                console.error(err);
            });
    }

    protected readonly ExportFileTypeModel = ExportFileTypeModel;
}
